<template>
  <div style="display: contents">
    <tr
      class="rbu-section-fluctuation-module-row"
      :class="fluctuation.ignored ? 'ignored' : ''"
    >
      <td class="rbu-section-fluctuation-column-1 rbu-table-section-header">
        <div v-if="idx === 0">Census Rate</div>
      </td>
      <td class="rbu-section-fluctuation-column-2">
        <div class="rbu-section-fluctuation-module-row-datapoint">
          <RbuPeriodInput
            outlined
            dense
            hide-details
            :value="fluctuation.current_period"
            @input="onPeriodUpdate($event, 'current')"
            :eventMonths="current_period_event"
            :disabled="idx === 0"
          ></RbuPeriodInput>
          <RbuDatapointInput
            dataset-type="FLUCTUATION"
            :period="fluctuation.current_period"
            :value="fluctuation.current_datapoint"
            @input="onDatapointUpdate(fluctuation.previous_datapoint, $event)"
          ></RbuDatapointInput>
          <div class="rbu-section-fluctuation-module-row-datapoint-label">
            {{ idx + 1 }}A
          </div>
        </div>
      </td>
      <td style="width: 100px; text-align: center; align-content: center">
        <div>
          {{ resultPercentage.toFixed(15) }}
        </div>
      </td>
      <td class="rbu-section-fluctuation-column-multiplier">
        <!-- {{ subTotalPercentage }} -->
      </td>
      <td
        class="rbu-section-fluctuation-column-formula"
        style="align-content: center"
      >
        <div
          class="rbu-section-fluctuation-module-row-formula-wrapper"
          style="display: flex; flex-direction: column"
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 0.5rem;
            "
          >
            <v-textarea
              outlined
              dense
              hide-details
              auto-grow
              rows="1"
              :value="formulaPrefix"
              @input="onFormulaUpdate($event, formulaSuffix)"
            ></v-textarea>
            <div class="rbu-section-fluctuation-module-row-formula-rate">
              Rate {{ subTotalPercentage ? `(${subTotalPercentage})` : "" }}
            </div>
            <v-textarea
              outlined
              dense
              hide-details
              auto-grow
              rows="1"
              :value="formulaSuffix"
              @input="onFormulaUpdate(formulaPrefix, $event)"
            ></v-textarea>
          </div>
          <!-- <span v-if="parsedFormula">Full Formula: {{ parsedFormula }}</span> -->
        </div>
      </td>
      <td
        class="rbu-section-fluctuation-column-descriptions"
        style="align-content: center"
      >
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="fluctuation.current_descriptions"
          @input="onUpdate({ current_descriptions: $event })"
        ></v-textarea>
      </td>
      <td
        class="rbu-section-fluctuation-column-actions"
        style="align-content: center"
      >
        <div
          class="rbu-section-fluctuation-module-row-action-wrapper"
          style="
            display: flex;
            flex-direction: row;
            align-items: top;
            justify-content: start;
          "
        >
          <v-btn
            icon
            color="primary"
            @click="$refs.fileInput.click()"
            v-if="!fluctuation.file"
          >
            <v-icon>mdi-upload</v-icon>
          </v-btn>
          <span v-else>
            <span
              class="rbu-section-fluctuation-module-file"
              @click="showFile(fluctuation.file)"
              >{{
                fluctuation.file instanceof File
                  ? fluctuation.file.name
                  : fluctuation.file.filename
              }}</span
            >
            <v-btn icon small color="primary" @click="onUpdate({ file: null })">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
          <input
            type="file"
            hidden
            ref="fileInput"
            @change="onFileInputChange"
          />

          <v-btn icon color="primary" @click="$emit('delete', idx)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-checkbox
            dense
            hide-details
            class="ignore-checkbox ml-4"
            style="padding-top: 0px"
            :input-value="fluctuation.ignored"
            @change="onUpdate({ ignored: $event })"
          >
            <template #label>
              <span
                style="
                  font-family: Roboto, sans-serif;
                  font-size: 14px;
                  font-weight: 500;
                  font-stretch: 100%;
                  letter-spacing: 1.25px;
                  line-height: normal;
                  text-indent: 1.25px;
                "
                >IGNORE</span
              >
            </template>
          </v-checkbox>
        </div>
      </td>
    </tr>

    <tr
      class="rbu-section-fluctuation-module-row with-border"
      :class="fluctuation.ignored ? 'ignored' : ''"
    >
      <td
        class="rbu-section-fluctuation-column-1 rbu-section-fluctuation-module-row-header"
      ></td>
      <td class="rbu-section-fluctuation-column-2">
        <div class="rbu-section-fluctuation-module-row-datapoint">
          <RbuPeriodInput
            outlined
            dense
            hide-details
            :value="fluctuation.previous_period"
            @input="onPeriodUpdate($event, 'previous')"
            :eventMonths="prev_period_event"
          ></RbuPeriodInput>
          <RbuDatapointInput
            dataset-type="FLUCTUATION"
            :period="fluctuation.previous_period"
            :value="fluctuation.previous_datapoint"
            @input="onDatapointUpdate($event, fluctuation.current_datapoint)"
          ></RbuDatapointInput>
          <div class="rbu-section-fluctuation-module-row-datapoint-label">
            {{ idx + 1 }}B
          </div>
        </div>
      </td>
      <td class="rbu-section-fluctuation-column-value"></td>
      <td class="rbu-section-fluctuation-column-multiplier"></td>
      <td class="rbu-section-fluctuation-column-formula"></td>
      <td class="rbu-section-fluctuation-column-descriptions">
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="fluctuation.previous_descriptions"
          @input="onUpdate({ previous_descriptions: $event })"
        ></v-textarea>
      </td>
      <td class="rbu-section-fluctuation-column-actions"></td>
    </tr>
    <tr>
      <td colspan="10">
        <v-divider></v-divider>
      </td>
    </tr>
  </div>
</template>
<script>
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import RbuDatapointInput from "@/components/rbu/RbuDatapointInput.vue";
import { computed, inject, ref, onMounted } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuSectionFluctuationRow",
  components: { RbuDatapointInput, RbuPeriodInput },
  props: {
    fluctuation: Object,
    idx: Number,
  },
  setup(props, { root, emit }) {
    const latest = inject("RBU_EDITION_LATEST");
    const base_start = inject("RBU_EDITION_BASE_START");
    const base_end = inject("RBU_EDITION_BASE_END");

    const current_period_event = ref([]);
    const prev_period_event = ref([]);

    const subTotalPercentage = computed(() => {
      if (
        props.fluctuation.previous_datapoint &&
        props.fluctuation.current_datapoint
      ) {
        return (
          (
            (parseFloat(props.fluctuation.current_datapoint.value) /
              parseFloat(props.fluctuation.previous_datapoint.value)) *
            100
          ).toFixed(2) + "%"
        );
      }
      return "";
    });

    const resultPercentage = computed(() => {
      try {
        let rate = 0;
        if (
          props.fluctuation.previous_datapoint &&
          props.fluctuation.current_datapoint
        ) {
          rate =
            parseFloat(props.fluctuation.current_datapoint.value) /
            parseFloat(props.fluctuation.previous_datapoint.value);
        }

        rate = floatingPointFix(rate);
        const formula = formulaPrefix.value + rate + formulaSuffix.value;
        const result = floatingPointFix(Number(eval(formula)));
        return result;
      } catch (e) {
        console.debug(e);
        return "-";
      }
    });

    const formulaPrefix = computed(() => {
      const components = (props.fluctuation.formula || "").split("{{VALUE}}");

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const formulaSuffix = computed(() => {
      const components = (props.fluctuation.formula || "").split("{{VALUE}}");

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });
    const onFormulaUpdate = function (prefix, suffix) {
      onUpdate({ formula: `${prefix}{{VALUE}}${suffix}` });
    };

    const onPeriodUpdate = async function (period, key) {
      // console.log("onPeriodUpdate", period, key);
      let d = {
        [`${key}_period`]: period,
      };

      let newPeriod =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[period] || period;
      let datapoint = props.fluctuation[`${key}_datapoint`];
      // console.log(newPeriod, datapoint);
      if (newPeriod && datapoint && datapoint.period !== newPeriod) {
        // Try getting the new datapoint
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [newPeriod],
              dataset: [datapoint.dataset.id],
              type: [datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          d[`${key}_datapoint`] = response.body.points[0];
        } else {
          d[`${key}_datapoint`] = null;
        }
      }

      onUpdate(d);
    };
    const onDatapointUpdate = async function (
      previous_datapoint,
      current_datapoint
    ) {
      console.debug(
        "onDatapointUpdate",
        props.fluctuation,
        previous_datapoint,
        current_datapoint
      );

      let updates = {
        previous_datapoint,
        current_datapoint,
      };

      let previous_period =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[props.fluctuation.previous_period] ||
        props.fluctuation.previous_period;
      if (
        previous_datapoint &&
        typeof previous_datapoint === "object" &&
        previous_datapoint.period !== previous_period
      ) {
        updates["previous_period"] = previous_datapoint.period;
        previous_period = previous_datapoint.period;
      }

      let current_period =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[props.fluctuation.current_period] || props.fluctuation.current_period;
      if (
        current_datapoint &&
        typeof current_datapoint === "object" &&
        current_datapoint.period !== current_period
      ) {
        updates["current_period"] = current_datapoint.period;
        current_period = current_datapoint.period;
      }

      if (!previous_datapoint && typeof current_datapoint === "object") {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [previous_period],
              dataset: [current_datapoint.dataset.id],
              type: [current_datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          updates.previous_datapoint = response.body.points[0];
        }
      } else if (!current_datapoint && typeof previous_datapoint === "object") {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [current_period],
              dataset: [previous_datapoint.dataset.id],
              type: [previous_datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          updates.current_datapoint = response.body.points[0];
        }
      }
      if (updates.current_datapoint) {
        getAvailablePeriod(updates.current_datapoint, "current");
      } else {
        current_period_event.value = [];
      }

      if (updates.previous_datapoint) {
        getAvailablePeriod(updates.previous_datapoint, "prev");
      } else {
        prev_period_event.value = [];
      }
      onUpdate(updates);
    };

    const getAvailablePeriod = async function (dp, type) {
      if (!dp) return;
      if (!dp.id) return;
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/datapoint/available_data_period/",
        params: {
          dp_id: dp.id,
        },
      });

      let events = [];
      if (response && response.data && response.data.success) {
        events = response.data.periods || [];
      }

      if (type === "current") {
        current_period_event.value = events;
      } else if (type === "prev") {
        prev_period_event.value = events;
      }
    };

    const fileInput = ref();
    const onFileInputChange = async function (e) {
      const FILE_SIZE_LIMITED = 2 * 1024 * 1024;
      const file = e.target.files[0];
      if (file.size > FILE_SIZE_LIMITED) {
        e.target.value = "";
        alert("The file size must not exceed 2MB.");
      } else {
        fileInput.value.value = "";
        if (file) {
          onUpdate({
            file,
          });
        }
      }
    };
    const showFile = function (file) {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      } else {
        root.$downloadFile(file.id);
      }
    };

    const parsedFormula = computed(() => {
      if (subTotalPercentage.value) {
        return `${formulaPrefix.value} ${subTotalPercentage.value} ${formulaSuffix.value}`;
      } else {
        return "";
      }
    });

    const onUpdate = _.debounce(function (evt) {
      console.debug("Fluctuation Row Update: ", evt);
      let updates = {
        ...props.fluctuation,
        ...evt,
      };

      if (updates.previous_datapoint && updates.current_datapoint) {
        let sub_total =
          parseFloat(updates.current_datapoint.value) /
          parseFloat(updates.previous_datapoint.value);

        sub_total = floatingPointFix(sub_total);
        if (updates.formula) {
          try {
            sub_total = floatingPointFix(
              eval(updates.formula.replace("{{VALUE}}", sub_total))
            );
          } catch (e) {
            console.debug(e);
          }
        }
        updates.sub_total = sub_total;
      }

      emit("update", updates);
    }, 500);

    onMounted(async () => {
      if (props.fluctuation && props.fluctuation.current_datapoint) {
        getAvailablePeriod(props.fluctuation.current_datapoint, "current");
      }

      if (props.fluctuation && props.fluctuation.previous_datapoint) {
        getAvailablePeriod(props.fluctuation.previous_datapoint, "prev");
      }
    });

    return {
      subTotalPercentage,
      formulaPrefix,
      formulaSuffix,
      onFormulaUpdate,
      onPeriodUpdate,
      onDatapointUpdate,
      fileInput,
      onFileInputChange,
      showFile,
      onUpdate,
      File,
      resultPercentage,
      parsedFormula,
      current_period_event,
      prev_period_event,
    };
  },
};
</script>

<style lang="less">
.rbu-section-fluctuation-module-row {
  td {
    padding: 0 8px;
  }

  &.ignored {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .rbu-section-fluctuation-column-value {
    display: flex;
    // justify-content: center;
    align-items: center;
    // text-align: center;
    background-color: aqua;
    .rbu-section-fluctuation-column-value-label {
      display: flex;
      align-items: center;
    }
  }

  .rbu-section-fluctuation-module-row-datapoint {
    padding: 8px 0;
    display: flex;
    gap: 8px;
  }

  .rbu-section-fluctuation-module-row-datapoint-label {
    display: flex;
    align-items: center;
  }

  .rbu-section-fluctuation-module-row-formula-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;

    .rbu-section-fluctuation-module-row-formula-rate {
      background-color: rgba(167, 18, 23, 1);
      color: white;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.15px;
      text-align: left;

      padding: 4px;
      gap: 10px;
      border-radius: 8px;
    }

    .rbu-section-fluctuation-module-row-formula-times {
      width: 24px;
      height: 24px;
      padding: 0 8px;
      gap: 10px;
      border-radius: 16px;
      background-color: rgba(255, 222, 48, 1);
    }
  }

  .rbu-section-fluctuation-module-row-action-wrapper {
    display: flex;

    .rbu-section-fluctuation-module-file {
      // font-size: 80%;
      font-size: 100%;
      word-break: break-all;
      text-decoration: underline;
      color: var(--v-primary-base);
      cursor: pointer;
      max-width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
    }

    .ignore-checkbox {
      i,
      label {
        color: var(--v-primary-base);
      }
    }
  }

  &.with-border {
    border-bottom: solid 1px black;
  }
}
</style>
